import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;

function loadCatalog() {
  if (!cache) {
    cache = Promise.all([api.get("/categories"), api.get("/cities")])
      .then(([g, c]) => ({ groups: g.data, cities: c.data }))
      .catch((e) => {
        cache = null;
        throw e;
      });
  }
  return cache;
}

export function useCatalog() {
  const [data, setData] = useState({ groups: [], cities: [], loading: true });
  useEffect(() => {
    let alive = true;
    loadCatalog()
      .then((d) => alive && setData({ ...d, loading: false }))
      .catch(() => alive && setData((s) => ({ ...s, loading: false })));
    return () => {
      alive = false;
    };
  }, []);
  const subcategories = data.groups.flatMap((g) => g.subcategories.map((s) => ({ ...s, group_name: g.name })));
  return { ...data, subcategories };
}
